import type { InvoiceData } from "@/apis/gql/types";
import { InvoiceStatus } from "@/lib/constants/invoiceStatus";
import { confColor } from "@/lib/miscellaneous/confidence-color";
import { cn } from "@/lib/utils";
import { formatInTimeZone } from "date-fns-tz";

type Props = {
  invoice: Pick<
    InvoiceData,
    | "invoiceDate"
    | "invoiceDateConfidence"
    | "status"
    | "splitPdf"
    | "isBooking"
  >;
  showConfidence?: boolean;
};

export const InvoiceDateCell = ({ invoice, showConfidence = false }: Props) => {
  if (
    invoice.status === InvoiceStatus.NEW ||
    invoice.status === InvoiceStatus.ERROR ||
    invoice.splitPdf === true ||
    !invoice.isBooking
  ) {
    return null;
  }

  const dateValue = invoice.invoiceDate;
  const invoiceDate = dateValue ? new Date(dateValue) : null;

  return (
    <div
      className={cn(
        "rounded h-auto w-auto p-1",
        confColor(showConfidence ? invoice.invoiceDateConfidence : undefined),
      )}
    >
      {invoiceDate
        ? formatInTimeZone(invoiceDate, "Europe/Berlin", "dd.MM.yy")
        : "–"}
    </div>
  );
};
